import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getallproductlines: option => request('v1/production/getallproductlines', option, true, false), // 查询商品系列列表
  getproducts: option => request('v1/product/getproducts', option, true, false), // 查询商品列表
  getproduct: option => {
    const urls = querystring(option)
    return request('v1/product/getproduct' + urls, {}, true, false) // 查询商品备案信息
  },
  addproduct: option => request('v1/product/addproduct', option, true, false), // 新增商品备案
  updateproduct: option =>
    request('v1/product/updateproduct', option, true, false), // 修改商品备案
  deleteproduct: option => {
    const urls = querystring(option)
    return request('v1/product/deleteproduct' + urls, {}, true, false) //  删除商品
  },
  getvendorsfromciqca: option => {
    const urls = querystring(option)
    return request('v1/product/getvendorsfromciqca' + urls, {}, true, false) //  查询老追溯系统中的企业
  },
  getproductsfromciqca: option => {
    const urls = querystring(option)
    return request('v1/product/getproductsfromciqca' + urls, {}, true, false) //  查询老追溯系统中的商品
  },
  synchroproductsfromciqca: option =>
    request('v1/product/synchroproductsfromciqca', option, true, false), //  同步老追溯系统的商品信息
  bindciqcavendor: option => {
    const urls = querystring(option)
    return request('v1/product/bindciqcavendor' + urls, {}, true, false) //  绑定老追溯系统中的企业
  },
  getboms: option => request('v1/production/getboms', option, true, false), // 查询boms列表
  getbom: option => {
    const urls = querystring(option)
    return request('v1/production/getbom' + urls, {}, true, false) // 查询boms信息
  },
  addbom: option => request('v1/production/addbom', option, true, false), // 新增boms备案
  updatebom: option =>
    request('v1/production/updatebom', option, true, false), // 修改boms备案
  updateproductline: option =>
    request('v1/production/updateproductline', option, true, false), // 修改boms备案
  getreworks: option => request('v1/production/rework/getreworks', option, true, false), // 查询返工单列表
  getordersource: option => {
    const urls = querystring(option)
    return request('v1/production/getordersource' + urls, {}, true, false) // 查询销售渠道对应的部门
  },
  getsafetystocks: option => request('v1/warehouse/getsafetystocks', option, true, false), // 获取商品安全库存信息
  setsafetystock: option => request('v1/warehouse/setsafetystock', option, true, false) // 设置商品安全库存信息
}
